<template>
  <div class="stat_box ">
    <!-- 第一行 -->
    <div class="stat_line2">
      <div class="stat_box1 dflex">
        <div class="flex1">
          <div class="name_line">新增会员数(人)</div>
          <div class="value_line">{{statData.inc_num}}</div>
        </div>
        <div class="cut_line1"></div>
        <div class="flex1">
          <div class="name_line">售卡金额(元)</div>
          <div class="value_line">{{statData.member_card_amount}}</div>
        </div>
      </div>
    </div>
    <!-- 第二行 -->
    <div class="stat_line2 dflex">
      <div class="stat_box2 mr15">
        <div class="item_title">售卡管理</div>
        <div class="dflex">
          <div class="flex1">
            <div class="name_line2">会员卡金卡</div>
            <div class="value_line">{{statData.sale_card_amount}}</div>
          </div>
          <div class="flex1">
            <div class="name_line2">汽油卡</div>
            <div class="value_line">{{statData.gasoli_card_amount}}</div>
          </div>
          <div class="flex1">
            <div class="name_line2">柴油卡</div>
            <div class="value_line">{{statData.diesel_card_amount}}</div>
          </div>
        </div>
      </div>
      <div class="stat_box2 mr15">
        <div class="item_title">汽油销售数据</div>
        <div class="dflex">
          <div class="flex1">
            <div class="name_line2">金额数(元)</div>
            <div class="value_line">{{statData.gasoli_amount}}</div>
          </div>
          <div class="flex1">
            <div class="name_line2">升数</div>
            <div class="value_line">{{statData.gasoli_num}}</div>
          </div>
          <div class="flex1">
            <div class="name_line2">单数</div>
            <div class="value_line">{{statData.gasoli_order_num}}</div>
          </div>
        </div>
      </div>
      <div class="stat_box2">
        <div class="item_title">柴油销售数据</div>
        <div class="dflex">
          <div class="flex1">
            <div class="name_line2">金额数(元)</div>
            <div class="value_line">{{statData.diesel_amount}}</div>
          </div>
          <div class="flex1">
            <div class="name_line2">升数</div>
            <div class="value_line">{{statData.diesel_num}}</div>
          </div>
          <div class="flex1">
            <div class="name_line2">单数</div>
            <div class="value_line">{{statData.diesel_order_num}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="stat_line2 dflex">
      <div class="stat_box3">
        <div class="item_title">线上消费</div>
        <div class="dflex">
          <div class="flex1">
            <div class="name_line2">总金额</div>
            <div class="value_line">{{statData.total_all}}</div>
          </div>
          <div class="flex1">
            <div class="name_line2">储值</div>
            <div class="value_line">{{statData.ex_goods_amount}}</div>
          </div>
          <div class="cut_line1" style="height:30px;"></div>
          <div class="flex1">
            <div class="name_line2">优惠金额</div>
            <div class="value_line">{{statData.free_amount}}</div>
          </div>
          <div class="flex1">
            <div class="name_line2">实收款</div>
            <div class="value_line">{{statData.total_amount}}</div>
          </div>
        </div>
      </div>
      <div class="stat_box3" style="width:402px">
        <div class="item_title">支付方式</div>
        <div class="dflex">
          <div class="flex1">
            <div class="name_line2">现金</div>
            <div class="value_line">{{statData.cash}}</div>
          </div>
          <div class="flex1">
            <div class="name_line2">银联</div>
            <div class="value_line">{{statData.unionpay}}</div>
          </div>
          <div class="flex1">
            <div class="name_line2">余额</div>
            <div class="value_line">{{statData.balance}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="stat_all">
      总计：收款金额 <span class="money_value">{{statData.total_amount}}</span> &nbsp;&nbsp;&nbsp;&nbsp; 优惠 <span class="money_value">{{statData.free_amount}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    statData: {
      type: Object,
      default:function(){
        return {};
      }
    }
  },
  data(){
    return{}
  }
}
</script>
<style lang="scss" scoped>
.dflex{
  display: flex;
}
.flex1{
  flex:1
}
.stat_line{
  color: #fff;
  margin-bottom: 10px;
  height: 60px;
  text-align: center;
  font-size: 12px;
  border-radius: 3px;
  .top_line{
    margin-top: 11px;
    line-height: 17px;
    margin-bottom: 4px;
  }
  .bottom_line{
    line-height: 17px;
  }
  .cut_line{
    margin-top:20px;
    height: 20px;
    border-right:1px solid #eee;
  }
  .mini_box{
    width: 138px;
    height: 60px;
  }
  .small_box{
    width: 263px;
  }
  .medium_box{
    width: 330px;
  }
  .large_box{
    width: 603px;
  }
  .box_style{
    border-radius: 3px;
    height: 60px;
    margin-right:10px;
  }
}
.max_line{
  width: 943px;
}
.stat_all{
  font-size: 14px;
  margin-bottom: 16px;
  .money_value{
    color: #f00;
  }
}

.stat_line2{
  margin-bottom: 16px;
  text-align: center;
  .stat_box1{
    width:263px;
    height: 65px;
    padding-top: 13px;
    padding-bottom: 11px;
    border: 1px solid #DADADA;
    border-radius: 3px;
  }
  .name_line{
    line-height: 17px;
    margin-bottom: 2px;
  }
  .name_line2{
    line-height: 17px;
    margin-bottom: 7px;
  }
  .value_line{
    line-height: 22px;
    color: #2F54EB;
    font-size: 16px;
    font-weight: 500;
  }
  .cut_line1{
    height: 21px;
    border-right: 1px solid #eee;
    margin-top: 9px;
  }
  .stat_box2{
    width: 330px;
    height: 100px;
    border: 1px solid #dadada;
    border-radius: 3px;
    margin-right: 15px;
  }
  .item_title{
    height: 30px;
    line-height: 30px;
    background: #f4f4f4;
    margin-bottom: 11px;
  }
  .stat_box3{
    width: 603px;
    height: 100px;
    border: 1px solid #dadada;
    border-radius: 3px;
    margin-right: 15px;
  }
}
</style>